import { TableCell as MaterialTableCell, styled } from "@mui/material";

export const TableCell = styled(MaterialTableCell)(() => ({
  fontSize: "0.8rem",
}));
